module.exports = __webpack_public_path__ + "static/media/icon-zoomout.4ec05f06.svg";